export default __webpack_public_path__ + "static/media/InsistentTautGodwit-small.dc7f1b78.gif";